import { useCallback, useRef, useState } from "react";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function BeforeAfterSlider({
  before, after, beforeLabel = "The Streets", afterLabel = "The Pack",
  showLabels = true, onReveal, testid = "ba-slider",
}) {
  const ref = useRef(null);
  const [pos, setPos] = useState(55);
  const revealed = useRef(false);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    let p = ((clientX - r.left) / r.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
    if (p <= 14 && !revealed.current) { revealed.current = true; onReveal && onReveal(); }
  }, [onReveal]);

  const onDown = (e) => {
    e.preventDefault();
    const move = (ev) => update(ev.touches ? ev.touches[0].clientX : ev.clientX);
    move(e.nativeEvent);
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      window.removeEventListener("pointercancel", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
    window.addEventListener("pointercancel", up);
  };

  return (
    <div ref={ref} onPointerDown={onDown}
      className="relative h-full w-full overflow-hidden cursor-ew-resize select-none touch-none bg-black"
      data-testid={testid}>
      {/* AFTER — base (full color, thriving) */}
      <img src={after} alt="after" draggable={false}
        className="absolute inset-0 h-full w-full object-cover pointer-events-none" />
      {showLabels && (
        <span className="absolute top-3 right-3 z-10 overline px-3 py-1 rounded-full bg-black/60 backdrop-blur text-secondary border border-secondary/40 pointer-events-none">
          {afterLabel}
        </span>
      )}

      {/* BEFORE — clipped from left (cold streets) */}
      <img src={before} alt="before" draggable={false}
        className="absolute inset-0 h-full w-full object-cover pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)`, filter: "grayscale(0.5) brightness(0.85)" }} />
      {showLabels && pos > 16 && (
        <span className="absolute top-3 left-3 z-10 overline px-3 py-1 rounded-full bg-black/60 backdrop-blur text-white/80 border border-white/30 pointer-events-none">
          {beforeLabel}
        </span>
      )}

      {/* Handle */}
      <div className="absolute top-0 bottom-0 z-20 pointer-events-none" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="h-full w-[3px] bg-primary" style={{ boxShadow: "0 0 14px #ff1493, 0 0 4px #ff1493" }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-primary text-primary-foreground grid place-items-center"
          style={{ boxShadow: "0 0 18px #ff1493" }}>
          <div className="flex items-center -space-x-1"><CaretLeft weight="bold" size={13} /><CaretRight weight="bold" size={13} /></div>
        </div>
      </div>

      {/* hint */}
      <span className="absolute bottom-2 left-1/2 -translate-x-1/2 z-10 overline text-[10px] tracking-[0.2em] text-white/70 pointer-events-none">
        ← slide the story →
      </span>
    </div>
  );
}
